// ===== User Roles =====
export const UserRole = {
  MANAGER: 'MANAGER',
  EMPLOYEE: 'EMPLOYEE',
  CUSTOMER: 'CUSTOMER',
  ADMIN: 'ADMIN',
} as const;

export type UserRole = (typeof UserRole)[keyof typeof UserRole];

export const UserRoleLabels: Record<UserRole, string> = {
  MANAGER: 'Менеджер',
  EMPLOYEE: 'Сотрудник',
  CUSTOMER: 'Клиент',
  ADMIN: 'Администратор',
};

// ===== Order Status =====
export const OrderStatus = {
  ARRIVED: 'ARRIVED',
  PARTIALLY_HANDED_OFF: 'PARTIALLY_HANDED_OFF',
  COMPLETED: 'COMPLETED',
} as const;

export type OrderStatus = (typeof OrderStatus)[keyof typeof OrderStatus];

export const OrderStatusLabels: Record<OrderStatus, string> = {
  ARRIVED: 'Заказ пришёл',
  PARTIALLY_HANDED_OFF: 'Частично выдан',
  COMPLETED: 'Заказ получен',
};

export const OrderStatusColors: Record<OrderStatus, string> = {
  ARRIVED: 'bg-blue-100 text-blue-700',
  PARTIALLY_HANDED_OFF: 'bg-amber-100 text-amber-700',
  COMPLETED: 'bg-green-100 text-green-700',
};

// ===== Notification Channel =====
export const NotificationChannel = {
  EMAIL: 'EMAIL',
  TELEGRAM: 'TELEGRAM',
  VK_MAX: 'VK_MAX',
  IN_APP: 'IN_APP',
} as const;

export type NotificationChannel = (typeof NotificationChannel)[keyof typeof NotificationChannel];

export const NotificationChannelLabels: Record<NotificationChannel, string> = {
  EMAIL: 'Email',
  TELEGRAM: 'Telegram',
  VK_MAX: 'VK Max',
  IN_APP: 'В приложении',
};

// ===== Notification Status =====
export const NotificationStatus = {
  PENDING: 'PENDING',
  SENT: 'SENT',
  FAILED: 'FAILED',
} as const;

export type NotificationStatus = (typeof NotificationStatus)[keyof typeof NotificationStatus];

export const NotificationStatusLabels: Record<NotificationStatus, string> = {
  PENDING: 'Ожидает',
  SENT: 'Отправлено',
  FAILED: 'Ошибка',
};
